import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getCourseSliceContent = createAsyncThunk('/courses/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getCourse`);
	return response;  
})

export const coursesSlice = createSlice({
    name: 'courses',
    initialState: {
        isLoading: false,
        courses : []
    },
    reducers: {
    },
    extraReducers: {
		[getCourseSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getCourseSliceContent.fulfilled]: (state, action) => {
			state.courses = action.payload.data
			state.isLoading = false
		},
		[getCourseSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default coursesSlice.reducer